export default __webpack_public_path__ + "static/media/element_spec_90.986fa49d.jpg";